import { extend } from "@react-three/fiber";
import { SplatMesh } from "@sparkjsdev/spark";

extend({ SplatMesh });
